const BtnLoader=()=>{
    return(<>
    <div className="spinner-border" role="status">
    </div>
    </>)
};

export default BtnLoader;